import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__header" }
const _hoisted_2 = { class: "popup__footer" }

import CloseButton from "@/components/UI/Button/CloseButton.vue";
import Popup from "@/components/UI/Pupup/Popup.vue";
import {computed} from "vue";

type Theme = 'light' | 'dark';


export default /*@__PURE__*/_defineComponent({
  __name: 'SplitPopup',
  props: /*@__PURE__*/_mergeModels({
  fullContentSize: {
    type: Boolean,
    default: false
  },
  fixedContentSize: {
    type: Boolean,
    default: false
  },
  filledContentSize: {
    type: Boolean,
    default: false
  },
  closeTheme: {
    type: String as () => Theme
  },
  theme: {
    type: String as () => Theme,
    default: 'light'
  }
}, {
    "show": {},
    "showModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["closeButtonClick"], ["update:show"]),
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const show = _useModel(__props, 'show')
const closeTheme = computed(() => props.closeTheme ? props.closeTheme : props.theme);
const close = () => {
  show.value = false;
}
const onCloseButtonClick = () => {
  close()
  emit('closeButtonClick');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    theme: __props.theme
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CloseButton, {
          onClick: onCloseButtonClick,
          theme: closeTheme.value
        }, null, 8, ["theme"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["popup__content", {fixedContentSize: __props.fixedContentSize, fullContentSize: __props.fullContentSize, filledContentSize: __props.filledContentSize}])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "footer", {
          class: "popup__footer",
          close: close
        })
      ])
    ]),
    _: 3
  }, 8, ["show", "theme"]))
}
}

})